import { render, staticRenderFns } from "./rollback.vue?vue&type=template&id=2b7d593a&scoped=true"
import script from "./rollback.vue?vue&type=script&lang=js"
export * from "./rollback.vue?vue&type=script&lang=js"
import style0 from "./rollback.vue?vue&type=style&index=0&id=2b7d593a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7d593a",
  null
  
)

export default component.exports